var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "register-page" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "header-back", on: { click: _vm.goBack } }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d: "M15 18L9 12L15 6",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "header-content" }, [
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.EDIT_IF ? "编辑资料" : "用户注册"))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "page-subtitle" }, [
            _vm._v(
              _vm._s(_vm.EDIT_IF ? "完善您的个人信息" : "加入Acuvue iLearn")
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-card" },
        [
          _c("van-form", { on: { submit: _vm.onSubmit } }, [
            _c("div", { staticClass: "form-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("span", { staticClass: "title-icon" }, [_vm._v("👤")]),
                _vm._v(" "),
                _c("span", [_vm._v("基本信息")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-group" },
                [
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      required: "",
                      name: "Identity",
                      value: _vm.Identity,
                      label: "机构类型",
                      placeholder: "请选择所属机构类型",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_Identity = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      attrs: {
                        position: "bottom",
                        round: "",
                        "get-container": "body"
                      },
                      model: {
                        value: _vm.showPicker_Identity,
                        callback: function($$v) {
                          _vm.showPicker_Identity = $$v
                        },
                        expression: "showPicker_Identity"
                      }
                    },
                    [
                      _c("van-picker", {
                        attrs: {
                          "show-toolbar": "",
                          title: "选择机构类型",
                          columns: [
                            "医院",
                            "视光中心",
                            "零售商",
                            "经销商",
                            "服务商",
                            "JJVC",
                            "高校",
                            "其他"
                          ]
                        },
                        on: {
                          confirm: _vm.onConfirm_Identity,
                          cancel: function($event) {
                            _vm.showPicker_Identity = false
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      name: "name",
                      required: "",
                      label: "姓名",
                      clearable: "",
                      placeholder: "请输入您的姓名",
                      maxlength: "11"
                    },
                    model: {
                      value: _vm.username,
                      callback: function($$v) {
                        _vm.username = $$v
                      },
                      expression: "username"
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      name: "phone",
                      required: "",
                      label: "手机号",
                      clearable: "",
                      disabled: _vm.EDIT_IF,
                      placeholder: "请输入您的手机号",
                      maxlength: "11"
                    },
                    model: {
                      value: _vm.userphone,
                      callback: function($$v) {
                        _vm.userphone = $$v
                      },
                      expression: "userphone"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.EDIT_IF
                    ? _c("van-field", {
                        attrs: {
                          type: "digit",
                          name: "CheckCode",
                          required: "",
                          label: "验证码",
                          placeholder: "请输入短信验证码",
                          maxlength: "6",
                          clearable: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button",
                              fn: function() {
                                return [
                                  _c(
                                    "van-button",
                                    {
                                      staticClass: "code-btn",
                                      class: {
                                        "code-btn-disabled": _vm.SEND_CODE_IF
                                      },
                                      attrs: {
                                        plain: "",
                                        size: "small",
                                        disabled: _vm.SEND_CODE_IF,
                                        "native-type": "button"
                                      },
                                      on: { click: _vm.sendCode }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.codeMsg) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          867679010
                        ),
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      name: "email",
                      label: "邮箱",
                      clearable: "",
                      placeholder: "请输入您的邮箱（选填）",
                      maxlength: "100"
                    },
                    model: {
                      value: _vm.useremail,
                      callback: function($$v) {
                        _vm.useremail = $$v
                      },
                      expression: "useremail"
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      name: "professiona",
                      label: "职称",
                      clearable: "",
                      placeholder: "请输入您的职称（选填）",
                      maxlength: "30"
                    },
                    model: {
                      value: _vm.userprofessiona,
                      callback: function($$v) {
                        _vm.userprofessiona = $$v
                      },
                      expression: "userprofessiona"
                    }
                  }),
                  _vm._v(" "),
                  _vm.Identity !== "零售商"
                    ? _c("van-field", {
                        attrs: {
                          name: "EnterpriseName",
                          required: _vm.isEnterpriseNameRequired,
                          label: "单位名称",
                          clearable: "",
                          placeholder: "请输入医院/企业/学校名称"
                        },
                        model: {
                          value: _vm.EnterpriseName,
                          callback: function($$v) {
                            _vm.EnterpriseName = $$v
                          },
                          expression: "EnterpriseName"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.Identity === "零售商"
                    ? [
                        _c("van-field", {
                          attrs: {
                            readonly: "",
                            clickable: "",
                            required: "",
                            label: "所在城市",
                            value: _vm.pca_text,
                            placeholder: "请选择您所在的城市",
                            "right-icon": "arrow-down"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showPopup(0)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("van-field", {
                          attrs: {
                            readonly: "",
                            clickable: "",
                            required: "",
                            label: "零售商",
                            value: _vm.account_text,
                            placeholder: "请选择零售商",
                            "right-icon": "arrow-down"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showlss(0)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("van-field", {
                          attrs: {
                            readonly: "",
                            clickable: "",
                            required: "",
                            label: "门店",
                            value: _vm.store_text,
                            placeholder: "请选择门店",
                            "right-icon": "arrow-down"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showmd(0)
                            }
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      required: "",
                      name: "position_pro",
                      label: "工作职责",
                      value: _vm.show_duty,
                      placeholder: "请选择您的工作职责",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_duty = true
                      }
                    }
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("span", { staticClass: "title-icon" }, [_vm._v("💼")]),
                _vm._v(" "),
                _c("span", [_vm._v("从业信息")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-group" },
                [
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      name: "vision_exp",
                      label: "从业时间",
                      value: _vm.show_time,
                      placeholder: "请选择从业时间",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_time = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "checkbox-field" },
                    [
                      _c("label", { staticClass: "checkbox-label" }, [
                        _vm._v("行业证书")
                      ]),
                      _vm._v(" "),
                      _c(
                        "van-checkbox-group",
                        {
                          staticClass: "checkbox-group",
                          model: {
                            value: _vm.ckbox_cfe,
                            callback: function($$v) {
                              _vm.ckbox_cfe = $$v
                            },
                            expression: "ckbox_cfe"
                          }
                        },
                        _vm._l(_vm.certOptions, function(cert) {
                          return _c(
                            "van-checkbox",
                            {
                              key: cert,
                              attrs: {
                                name: cert,
                                shape: "square",
                                "checked-color": "#00b7ee"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cert) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("span", { staticClass: "title-icon" }, [_vm._v("🎓")]),
                _vm._v(" "),
                _c("span", [_vm._v("教育信息")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-group" },
                [
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      required: "",
                      name: "edu_qual",
                      label: "学历",
                      value: _vm.show_record,
                      placeholder: "请选择学历",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_record = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      required: "",
                      name: "Major",
                      label: "专业",
                      value: _vm.show_subject,
                      placeholder: "请选择专业",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_subject = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      readonly: "",
                      clickable: "",
                      required: "",
                      name: "graduation_year",
                      label: "毕业年份",
                      value: _vm.show_year,
                      placeholder: "请选择毕业年份",
                      "right-icon": "arrow-down"
                    },
                    on: {
                      click: function($event) {
                        _vm.showPicker_year = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      name: "ins_gra",
                      required: "",
                      label: "毕业院校",
                      placeholder: "请输入毕业院校",
                      clearable: ""
                    },
                    model: {
                      value: _vm.ins_gra,
                      callback: function($$v) {
                        _vm.ins_gra = $$v
                      },
                      expression: "ins_gra"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit-section" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "submit-btn",
                    attrs: {
                      round: "",
                      block: "",
                      type: "info",
                      "native-type": "submit",
                      loading: _vm.submitting,
                      disabled: _vm.submitting
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.EDIT_IF ? "保存修改" : "立即注册") +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.show_city,
            callback: function($$v) {
              _vm.show_city = $$v
            },
            expression: "show_city"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "选择城市",
              columns: _vm.area_list
            },
            on: {
              confirm: _vm.onConfirm_addr,
              cancel: function($event) {
                _vm.show_city = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.show_account,
            callback: function($$v) {
              _vm.show_account = $$v
            },
            expression: "show_account"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "选择零售商",
              columns: _vm.account_list,
              "value-key": "Account_Short_Name__c"
            },
            on: {
              confirm: _vm.onConfirm_account,
              cancel: function($event) {
                _vm.show_account = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.show_store,
            callback: function($$v) {
              _vm.show_store = $$v
            },
            expression: "show_store"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "选择门店",
              columns: _vm.store_list,
              "value-key": "Title"
            },
            on: {
              confirm: _vm.onConfirm_store,
              cancel: function($event) {
                _vm.show_store = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.showPicker_duty,
            callback: function($$v) {
              _vm.showPicker_duty = $$v
            },
            expression: "showPicker_duty"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "工作职责",
              columns: _vm.columns_duty
            },
            on: {
              confirm: _vm.onConfirm_duty,
              cancel: function($event) {
                _vm.showPicker_duty = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.showPicker_time,
            callback: function($$v) {
              _vm.showPicker_time = $$v
            },
            expression: "showPicker_time"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "从业时间",
              columns: _vm.columns_time
            },
            on: {
              confirm: _vm.onConfirm_time,
              cancel: function($event) {
                _vm.showPicker_time = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.showPicker_record,
            callback: function($$v) {
              _vm.showPicker_record = $$v
            },
            expression: "showPicker_record"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "学历",
              columns: [
                "大专",
                "理学本科",
                "医学本科",
                "研究生",
                "博士",
                "其他"
              ]
            },
            on: {
              confirm: _vm.onConfirm_record,
              cancel: function($event) {
                _vm.showPicker_record = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.showPicker_subject,
            callback: function($$v) {
              _vm.showPicker_subject = $$v
            },
            expression: "showPicker_subject"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "专业",
              columns: ["视光", "医学", "其他"]
            },
            on: {
              confirm: _vm.onConfirm_subject,
              cancel: function($event) {
                _vm.showPicker_subject = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", round: "", "get-container": "body" },
          model: {
            value: _vm.showPicker_year,
            callback: function($$v) {
              _vm.showPicker_year = $$v
            },
            expression: "showPicker_year"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              title: "毕业年份",
              columns: _vm.columns_year
            },
            on: {
              confirm: _vm.onConfirm_year,
              cancel: function($event) {
                _vm.showPicker_year = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-decoration" }, [
      _c("div", { staticClass: "deco-circle deco-circle-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "deco-circle deco-circle-2" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77453986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77453986","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/register.vue
// module id = null
// module chunks = 